import { CREATE_APOLICE, UPDATE_APOLICE, CREATE_APOLICE_FAIL, CREATE_APOLICE_SUCCESS, UPDATE_APOLICE_SUCCESS, UPDATE_APOLICE_FAIL, DELETE_APOLICE, DELETE_APOLICE_SUCCESS, DELETE_APOLICE_FAIL } from "./actionTypes"

export const createApolice = apolice => ({
  type: CREATE_APOLICE,
  payload: apolice,
})

export const createApoliceSuccess = apolice => ({
  type: CREATE_APOLICE_SUCCESS,
  payload: apolice,
})

export const createApoliceFail = error => ({
  type: CREATE_APOLICE_FAIL,
  payload: error,
})

export const updateApolice = apolice => ({
  type: UPDATE_APOLICE,
  payload: apolice,
})

export const updateApoliceSuccess = apolice => ({
  type: UPDATE_APOLICE_SUCCESS,
  payload: apolice,
})

export const updateApoliceFail = error => ({
  type: UPDATE_APOLICE_FAIL,
  payload: error,
})

export const deleteApolice = apolice => ({
  type: DELETE_APOLICE,
  payload: apolice,
})

export const deleteApoliceSuccess = apolice => ({
  type: DELETE_APOLICE_SUCCESS,
  payload: apolice,
})

export const deleteApoliceFail = error => ({
  type: DELETE_APOLICE_FAIL,
  payload: error,
})
